import { jsx as _jsx } from "react/jsx-runtime";
import MediaPickerModal from "@widget/forms/inputs/MediaPicker/MediaPickerModal";
/**
 * The font-icon browse dialog — the shared MediaPicker panel opened on its
 * Icons tab. `mediaTypes: ['Icon']` also enables the library, upload and URL
 * sources, all of which produce values `Icon` can render; pass `sources` to
 * narrow that.
 */
const IconPickerModal = (props) => {
    const { show, onClose, onSelect, currentValue, sources, allowedTypes, defaultSource } = props;
    return (_jsx(MediaPickerModal, { show: show, onClose: onClose, onSelect: onSelect, mediaTypes: ['Icon'], sources: sources, allowedTypes: allowedTypes, defaultSource: defaultSource !== null && defaultSource !== void 0 ? defaultSource : 'icons', currentValue: currentValue }));
};
export default IconPickerModal;
